import { Box } from '@mui/material'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import TableContainer from '@mui/material/TableContainer'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { isFactWeightDeviation } from './feedPlanDeviation'
import FactTimeValue from './FactTimeValue'
import { PlanFeedFieldName } from '../../models'
import { IFeedTableProps } from '../../models/IFeed'
import { COLORS } from '../../styles/colors'
import { TypographySecondary } from '../../ui/typography/TypographySecondary'
import { PlanFeedField } from './PlanFeedField'

const PlanDistributionTable = (props: IFeedTableProps) => {
	return (
		<Box sx={{ pt: '24px' }}>
			<TableContainer sx={{ p: '12px 18px 12px 8px' }}>
				<Table
					sx={{
						minWidth: 650,
						[`& .${tableCellClasses.root}`]: {
							borderBottom: 'none',
						},
					}}
					aria-label='simple table'
				>
					<TableHead sx={{ borderBottom: 'none' }}>
						<TableRow
							sx={{ borderBottom: `1px solid ${COLORS.secondaryFontOpacity}` }}
						>
							<TableCell
								align='left'
								sx={{ width: '220px', paddingLeft: '8px', textAlign: 'left' }}
							>
								<TypographySecondary>Группа</TypographySecondary>
							</TableCell>
							<TableCell align='center'>
								<TypographySecondary>Вес раздачи</TypographySecondary>
							</TableCell>
							<TableCell align='center'>
								<TypographySecondary>Плановое время</TypographySecondary>
							</TableCell>
							<TableCell align='center'>
								<TypographySecondary>Фактическое время</TypographySecondary>
							</TableCell>
							<TableCell align='right'>
								<TypographySecondary
									sx={{
										display: 'block',
										width: '166px',
										ml: 'auto',
										textAlign: 'center',
									}}
								>
									Фактический вес
									<br />
									раздачи
								</TypographySecondary>
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{props.groupsArray.map((el, index) => {
							const weightDeviation = isFactWeightDeviation(
								el,
								props.feedPlanDate,
								props.deviation,
								el.plan_time,
							)
							return (
								<TableRow key={index}>
									<TableCell
										component='th'
										scope='row'
										align='left'
										sx={{ paddingLeft: '8px' }}
									>
										<Box
											display='flex'
											flexDirection='row'
											alignItems='baseline'
										>
											{el.group.title}
											<TypographySecondary sx={{ pl: '4px' }}>
												{el.group.barn.title}
											</TypographySecondary>
										</Box>
									</TableCell>
									<TableCell align='center'>
										<TypographyPrimary>
											{el.food_weight}{' '}
											<span style={{ color: COLORS.icon }}>кг</span>
										</TypographyPrimary>
									</TableCell>
									<TableCell align='center'>{el.plan_time}</TableCell>
									<TableCell align='center'>
										<FactTimeValue
											factDt={el.fact_dt}
											planTime={el.plan_time}
											date={props.feedPlanDate}
											deviation={props.deviation}
										/>
									</TableCell>
									<TableCell
										key={`viewPlanListDistributionTableCellDry${props.uniqueKey}${el.group.id}`}
										align='right'
									>
										<Box
											sx={{
												display: 'flex',
												alignItems: 'center',
												justifyContent: 'flex-end',
												gap: '8px',
											}}
										>
											<PlanFeedField
												isFutureDate={props.isFuture}
												factDt={el.fact_dt}
												type='number'
												label={'кг'}
												key={`distributionViewPlanFeedTableFieldWeight${props.uniqueKey}${el.group.id}`}
												value={el.weight}
												feedPlanDate={props.feedPlanDate}
												groupId={el.group.id}
												fieldName={PlanFeedFieldName.WEIGHT}
												planId={props.planId}
												metaFlags={el.has_fact_data_demand}
												hasWeightDeviation={weightDeviation}
											/>
										</Box>
									</TableCell>
								</TableRow>
							)
						})}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	)
}

export default PlanDistributionTable
